import React from 'react';
import { Modal } from 'react-bootstrap';
import { CXButton } from '../../../components/CXForm';

interface ClosedWithoutActionConfirmModalProps {
    show: boolean;
    onBack: () => void;
    onConfirm: () => void;
}

const ClosedWithoutActionConfirmModal: React.FC<ClosedWithoutActionConfirmModalProps> = ({
    show,
    onBack,
    onConfirm,
}) => {
    return (
        <Modal show={show} onHide={onBack} size="lg">
            <Modal.Header closeButton>
                <Modal.Title>Closed without action</Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <div
                    style={{
                        fontSize: 14,
                        lineHeight: '20px',
                        color: '#4C4C4C',
                    }}
                >
                    Are you sure you want to close this case without action?
                </div>
            </Modal.Body>

            <Modal.Footer>
                <div style={{ width: 200 }}>
                    <CXButton
                        outline
                        text="Back"
                        onClick={onBack}
                        fontSize="16px"
                        width="100%"
                    />
                </div>
                <div style={{ width: 200 }}>
                    <CXButton
                        text="Confirm"
                        onClick={onConfirm}
                        fontSize="16px"
                        width="100%"
                    />
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default ClosedWithoutActionConfirmModal;
